import React, { FC } from 'react'
import { useLocalization } from '@libs/localization'
import { Typography } from 'antd'
import { NoImage32 } from '@carbon/icons-react'
import { PresentationPageContentProps } from 'modules/material/PresentationPageContent'
import ErrorPage from 'modules/common/ErrorPage'
import Styled from 'modules/common/ErrorPage/Styled'
import appRoutes from '../../../app.routes'

const PresentationMaterialNotFound: FC<PresentationPageContentProps> = ({ filter, caseId }) => {
	const { t } = useLocalization()
	const materialsFilter = filter === 'active' ? 'active' : 'any'
	const title = t('materials.pages.presentation.noMaterials', { caseId, materialsFilter })

	const content = (
		<Styled.Container display="flex" justifyContent="center" alignItems="center" flexDirection="column">
			<Typography>{t('materials.pages.presentation.noMaterials', { caseId, materialsFilter })}</Typography>
			<NoImage32 />
		</Styled.Container>
	)

	return <ErrorPage standalonePage title={title} contentChild={content} logoLink={appRoutes.externalLinks.esoft()} />
}

export default PresentationMaterialNotFound
